<style src="./BlockNavigation.scss" lang="scss"></style>

<script>
	/**
	 * Navigation of section blocks.
	 * @vue-prop {string} headline The Headline of Navigation
	 * @vue-prop {link} link The endpoint of navigation headline link
	 * @vue-prop {Object[]} list A list of objects containing the sublinks of navigation
	 * @listens Document#colCountChanged
	 */
	export default {
		name: 'HpBlockNavigation',
		props: ['headline', 'link', 'list'],
		data () {
			return {};
		},
		methods: {
			/**
			 * Checks if there's still space for the navigation sub links and sets those breaking out of the border to invisible
			 */
			showhideHandler () {
				let nav = this.$el.querySelector('nav');
				if (nav) {
					let gap = document.documentElement.style.getPropertyValue('--grid-column-gap').replace(/\D/g, '');
					gap = gap !== '' ? gap : 30; // 30px is the default value
					let space = nav.offsetWidth;
					let list = this.$el.querySelectorAll('nav ul li');
					for (let i = 0; i < list.length; i++) {
						space -= list[i].offsetWidth;
						if (space >= 0) {
							list[i].style.visibility = '';
							space -= gap;
						} else {
							list[i].style.visibility = 'hidden';
						}
					}
				}
			}
		},
		mounted () {
			document.addEventListener('colCountChanged', () => {
				this.$nextTick(() => {
					this.showhideHandler();
				});
			});
			document.addEventListener('gridGapChanged', () => {
				this.$nextTick(() => {
					this.showhideHandler();
				});
			});

			this.$nextTick(() => {
				this.showhideHandler();
			});
		}
	};
</script>

<template>
	<div data-component="block-navigation" data-grid-row>
		<h2>
			<a :href="link">
				{{ headline }}
			</a>
		</h2>
		<nav>
			<ul data-grid-row>
				<li v-for="(element, index) in list" :key="index">
					<a :href="element.link">
						{{ element.text }}
					</a>
				</li>
			</ul>
		</nav>
	</div>
</template>
